module.exports = __webpack_public_path__ + "static/media/fbIcon.37863798.svg";